import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { EnergyService } from "../energy.service";
import { HistoricVar } from "../../devices/device.model";
import { SharedUtils } from "../../../shared/shared.utils";
import { GeneralService } from "../../../shared/services/general.service";
import { SessionStateService } from "../../../core/services/session-state.service";
import { DevicesService } from "../../devices/devices.service";
import { Observable } from "rxjs";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-energy-consumption",
  templateUrl: "./energy-consumption.component.html",
  styleUrls: ["./energy-consumption.component.scss"],
})
export class EnergyConsumptionComponent implements OnInit, OnChanges {
  @Input() clientHasGas;
  @Input() isJustConsumption = false;
  @Input() viewMode: string;
  varStats: Map<string, HistoricVar>;
  todayValue: string | number = 0;
  monthValue: string | number = 0;
  estimationValue: string | number = 0;
  loaded = false;
  SharedUtils = SharedUtils;
  constructor(
    private energyService: EnergyService,
    private devicesService: DevicesService,
    private sessionStateService: SessionStateService
  ) {}

  ngOnChanges() {
    this.refreshValues();
  }
  ngOnInit() {
    this.refreshValues();
  }

  refreshValues() {
    this.loaded = false;
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        if (smartMeter[0]) {
          this.energyService
            .getTotals(this.sessionStateService.getHouse().houseId)
            .catch((err) => {
              this.todayValue = "-";
              this.monthValue = "-";
              this.estimationValue = "-";
              this.loaded = true;
              return of(empty);
            })
            .subscribe((totals) => {
              console.log(totals);
              if (this.viewMode === "Eur") {
                this.todayValue =
                  totals["consumption"]["today"]["cost"] !== "-,--" &&
                  totals["consumption"]["today"]["cost"] >= 0.1
                    ? totals["consumption"]["today"]["cost"]
                    : "-";
                this.monthValue =
                  totals["consumption"]["thisMonth"]["cost"] !== "-,--" &&
                  totals["consumption"]["thisMonth"]["cost"] >= 0.1
                    ? totals["consumption"]["thisMonth"]["cost"]
                    : "-";
                this.estimationValue =
                  totals["consumption"]["prediction"]["cost"] !== "-,--" &&
                  totals["consumption"]["prediction"]["cost"] >= 0.1
                    ? totals["consumption"]["prediction"]["cost"]
                    : "-";
              } else {
                this.todayValue =
                  totals["consumption"]["today"]["value"] !== "-,--" &&
                  totals["consumption"]["today"]["cost"] >= 0.1
                    ? totals["consumption"]["today"]["value"]
                    : "-";
                this.monthValue =
                  totals["consumption"]["thisMonth"]["value"] !== "-,--" &&
                  totals["consumption"]["thisMonth"]["cost"] >= 0.1
                    ? totals["consumption"]["thisMonth"]["value"]
                    : "-";
                this.estimationValue =
                  totals["consumption"]["prediction"]["value"] !== "-,--" &&
                  totals["consumption"]["prediction"]["cost"] >= 0.1
                    ? totals["consumption"]["prediction"]["value"]
                    : "-";
              }

              this.loaded = true;
            });
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-consumption/energy-consumption.component.ts